import _ from 'lodash';
import { CAMPAIGN_TYPE } from '../virtual-event.enums';

export class CampaignOptionModel {
    public data: any = null;
    
    public classList: any = [];

    public isLive: boolean = false;
    public isDisabled: boolean = false;

    constructor(campaign: any, data: any) {
        this.data = data;

        switch(campaign.type) {
            case CAMPAIGN_TYPE.AUCTION:
                this.isDisabled = data.count - data.soldCount < 1;
                break;
            case CAMPAIGN_TYPE.LAST_HERO:
                this.isDisabled = _.get(campaign, 'campaignTypeData.status', 0) === 1 ? true: false;
                break;
        }
    }
}